"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealMilkFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealMilkFilled = function MealMilkFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.907 17.593l-2.626-2.626c-.04-.037-2.948-2.937-2.948-2.937-1.833-1.53-4.464-1.983-6.606-.96l-1.656-1.656a1 1 0 00-1.414 0l-4.243 4.243a1 1 0 000 1.414l1.655 1.656a6.003 6.003 0 00.988 6.635l2.91 2.92 2.626 2.625 11.314-11.314zm1.414 1.414L19.007 30.321l1.014 1.013a4 4 0 005.657 0l5.656-5.656a4 4 0 000-5.657l-1.013-1.014zM12.95 8.707a1 1 0 10-1.414-1.414l-4.243 4.243a1 1 0 101.414 1.414l4.243-4.243z",
    fill: "#97BA1E"
  }));
};

exports.MealMilkFilled = MealMilkFilled;
var _default = MealMilkFilled;
exports.default = _default;